// import React from "react";
// import { motion } from "framer-motion";
// import Button from "../ui/Button";

// export default function Services() {
//   const services = [
//     {
//       icon: "🏍️",
//       title: "Bike Rides",
//       description: "Quick and economical rides",
//       price: "Starting ₹25",
//       color: "linear-gradient(135deg, #E63946, #dc2626)",
//       border: "#dc2626",
//     },
//     {
//       icon: "🛺",
//       title: "Auto Rides",
//       description: "Affordable auto rickshaw rides",
//       price: "Starting ₹39",
//       color: "linear-gradient(135deg, #22c55e, #14b8a6)",
//       border: "#22c55e",
//     },
//     {
//       icon: "🚗",
//       title: "Car Rides",
//       description: "Comfortable family rides",
//       price: "Starting ₹99",
//       color: "linear-gradient(135deg, #FFC300, #f97316)",
//       border: "#f59e0b",
//     },
//     {
//       icon: "💼",
//       title: "Corporate Rides",
//       description: "Business professional packages",
//       price: "Custom Plans",
//       color: "linear-gradient(135deg, #a855f7, #6366f1)",
//       border: "#8b5cf6",
//     },
//   ];

//   const width = typeof window !== "undefined" ? window.innerWidth : 1024;

//   // animation variants
//   const containerVariants = {
//     hidden: { opacity: 0 },
//     show: {
//       opacity: 1,
//       transition: {
//         staggerChildren: 0.2,
//       },
//     },
//   };

//   const cardVariants = {
//     hidden: { opacity: 0, y: 50 },
//     show: {
//       opacity: 1,
//       y: 0,
//       transition: { duration: 0.6, ease: "easeOut" },
//     },
//   };

//   return (
//     <section
//       id="services"
//       style={{
//         padding: width < 768 ? "60px 16px" : "96px 20px",
//         background: "linear-gradient(to bottom, white, #F8F9FA)",
//       }}
//     >
//       <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
//         {/* Header */}
//         <motion.div
//           initial={{ opacity: 0, y: 40 }}
//           whileInView={{ opacity: 1, y: 0 }}
//           transition={{ duration: 0.6, ease: "easeOut" }}
//           viewport={{ once: true }}
//           style={{ textAlign: "center", marginBottom: width < 768 ? "40px" : "64px" }}
//         >
//           <span
//             style={{
//               background: "linear-gradient(to right, #E63946, #FFC300)",
//               color: "white",
//               padding: width < 768 ? "6px 18px" : "8px 24px",
//               borderRadius: "50px",
//               fontSize: width < 768 ? "18px" : "24px",
//               fontWeight: "600",
//             }}
//           >
//             Our Services
//           </span>

//           <h2
//             style={{
//               fontSize: width < 768 ? "clamp(24px, 6vw, 36px)" : "clamp(32px, 6vw, 48px)",
//               fontWeight: "bold",
//               color: "#1C1C1C",
//               margin: "24px 0 16px",
//             }}
//           >
//             Ride Your{" "}
//             <span
//               style={{
//                 background: "linear-gradient(to right, #E63946, #FFC300)",
//                 WebkitBackgroundClip: "text",
//                 WebkitTextFillColor: "transparent",
//               }}
//             >
//               Way
//             </span>
//           </h2>

//           <p
//             style={{
//               fontSize: width < 768 ? "14px" : "18px",
//               color: "#6C757D",
//               maxWidth: "700px",
//               margin: "0 auto",
//               lineHeight: "1.6",
//             }}
//           >
//             Choose from bikes, autos, cars, or corporate rides — we've got the perfect option for every journey.
//           </p>
//         </motion.div>

//         {/* Services Grid */}
//         <motion.div
//           variants={containerVariants}
//           initial="hidden"
//           whileInView="show"
//           viewport={{ once: true }}
//           style={{
//             display: "grid",
//             gridTemplateColumns: width < 500 ? "1fr" : "repeat(auto-fit, minmax(250px, 1fr))",
//             gap: width < 768 ? "20px" : "32px",
//           }}
//         >
//           {services.map((service, index) => (
//             <motion.div
//               key={index}
//               variants={cardVariants}
//               whileHover={{
//                 scale: 1.05,
//                 boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
//                 transition: { duration: 0.3 },
//               }}
//               style={{
//                 background: "white",
//                 borderRadius: "24px",
//                 padding: width < 768 ? "24px" : "32px",
//                 boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
//                 transition: "all 0.4s ease",
//                 position: "relative",
//                 overflow: "hidden",
//                 border: `2px solid transparent`,
//               }}
//               onMouseEnter={(e) => {
//                 e.currentTarget.style.border = `2px solid ${service.border}`;
//               }}
//               onMouseLeave={(e) => {
//                 e.currentTarget.style.border = "2px solid transparent";
//               }}
//             >
//               <div
//                 style={{
//                   position: "absolute",
//                   top: "-20px",
//                   right: "-20px",
//                   fontSize: width < 768 ? "80px" : "120px",
//                   opacity: 0.1,
//                   zIndex: 0,
//                 }}
//               >
//                 {service.icon}
//               </div>

//               <div
//                 style={{
//                   width: width < 768 ? "64px" : "80px",
//                   height: width < 768 ? "64px" : "80px",
//                   background: service.color,
//                   borderRadius: "16px",
//                   display: "flex",
//                   alignItems: "center",
//                   justifyContent: "center",
//                   fontSize: width < 768 ? "32px" : "40px",
//                   marginBottom: "24px",
//                   boxShadow: "0 10px 20px rgba(0,0,0,0.2)",
//                   zIndex: 1,
//                 }}
//               >
//                 {service.icon}
//               </div>

//               <h3
//                 style={{
//                   fontSize: width < 768 ? "20px" : "24px",
//                   fontWeight: "bold",
//                   color: "#1C1C1C",
//                   marginBottom: "12px",
//                   position: "relative",
//                   zIndex: 1,
//                 }}
//               >
//                 {service.title}
//               </h3>

//               <p
//                 style={{
//                   color: "#6C757D",
//                   marginBottom: "24px",
//                   position: "relative",
//                   zIndex: 1,
//                   fontSize: width < 768 ? "14px" : "16px",
//                 }}
//               >
//                 {service.description}
//               </p>

//               <div
//                 style={{
//                   fontSize: width < 768 ? "16px" : "18px",
//                   fontWeight: "bold",
//                   marginBottom: "16px",
//                   background: service.color,
//                   WebkitBackgroundClip: "text",
//                   WebkitTextFillColor: "transparent",
//                   position: "relative",
//                   zIndex: 1,
//                 }}
//               >
//                 {service.price}
//               </div>

//               {/* Commented out the Book Now button */}
//               {/*
//               <div style={{ position: "relative", zIndex: 1 }}>
//                 <Button
//                   style={{
//                     fontSize: width < 768 ? "14px" : "16px",
//                     padding: width < 768 ? "8px 20px" : "12px 24px",
//                   }}
//                 >
//                   Book Now
//                 </Button>
//               </div>
//               */}
//             </motion.div>
//           ))}
//         </motion.div>
//       </div>
//     </section>
//   );
// }











































import React, { useState, useEffect } from "react";
import { motion } from "framer-motion";
import Button from "../ui/Button";

export default function Services() {
  const [width, setWidth] = useState(typeof window !== "undefined" ? window.innerWidth : 1024);

  useEffect(() => {
    const handleResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

  const isMobile = width < 768;

  const services = [
    {
      icon: "🏍️",
      title: "Bike Rides",
      description: "Quick and economical rides",
      price: "Starting ₹25",
      color: "linear-gradient(135deg, #E63946, #dc2626)",
      border: "#dc2626",
    },
    {
      icon: "🛺",
      title: "Auto Rides",
      description: "Affordable auto rickshaw rides",
      price: "Starting ₹39",
      color: "linear-gradient(135deg, #22c55e, #14b8a6)",
      border: "#22c55e",
    },
    {
      icon: "🚗",
      title: "Car Rides",
      description: "Comfortable family rides",
      price: "Starting ₹99",
      color: "linear-gradient(135deg, #FFC300, #f97316)",
      border: "#f59e0b",
    },
    {
      icon: "📦",
      title: "Parcels",
      description: "Send packages safely and quickly",
      price: "Starting ₹49",
      color: "linear-gradient(135deg, #f43f5e, #ec4899)",
      border: "#f43f5e",
    },
  ];

  const containerVariants = {
    hidden: { opacity: 0 },
    show: { opacity: 1, transition: { staggerChildren: 0.2 } },
  };

  const cardVariants = {
    hidden: { opacity: 0, y: 50 },
    show: { opacity: 1, y: 0, transition: { duration: 0.6, ease: "easeOut" } },
  };

  return (
    <section
      id="services"
      style={{
        padding: isMobile ? "60px 16px" : "96px 20px",
        background: "linear-gradient(to bottom, white, #F8F9FA)",
      }}
    >
      <div style={{ maxWidth: "1280px", margin: "0 auto" }}>
        {/* Header */}
        <motion.div
          initial={{ opacity: 0, y: 40 }}
          whileInView={{ opacity: 1, y: 0 }}
          transition={{ duration: 0.6, ease: "easeOut" }}
          viewport={{ once: true }}
          style={{ textAlign: "center", marginBottom: isMobile ? "40px" : "64px" }}
        >
          <span
            style={{
              background: "linear-gradient(to right, #E63946, #FFC300)",
              color: "white",
              padding: isMobile ? "6px 18px" : "8px 24px",
              borderRadius: "50px",
              fontSize: isMobile ? "18px" : "24px",
              fontWeight: "600",
            }}
          >
            Our Services
          </span>

          <h2
            style={{
              fontSize: isMobile ? "clamp(24px,6vw,36px)" : "clamp(32px,6vw,48px)",
              fontWeight: "bold",
              color: "#1C1C1C",
              margin: "24px 0 16px",
            }}
          >
            Ride Your {" "}
            <span
              style={{
                background: "linear-gradient(to right, #E63946, #FFC300)",
                WebkitBackgroundClip: "text",
                WebkitTextFillColor: "transparent",
              }}
            >
              Way
            </span>
          </h2>

          <p
            style={{
              fontSize: isMobile ? "14px" : "18px",
              color: "#6C757D",
              maxWidth: "700px",
              margin: "0 auto",
              lineHeight: "1.6",
            }}
          >
            Choose from bikes, autos, cars or parcel delivery — we've got the perfect option for every journey.
          </p>
        </motion.div>

        {/* Services Grid */}
        <motion.div
          variants={containerVariants}
          initial="hidden"
          whileInView="show"
          viewport={{ once: true }}
          style={{
            display: "grid",
            gridTemplateColumns: isMobile ? "1fr" : "repeat(auto-fit, minmax(250px, 1fr))",
            gap: isMobile ? "20px" : "32px",
          }}
        >
          {services.map((service, index) => (
            <motion.div
              key={index}
              variants={cardVariants}
              whileHover={{
                scale: 1.05,
                boxShadow: "0 20px 40px rgba(0,0,0,0.15)",
                transition: { duration: 0.3 },
              }}
              style={{
                background: "white",
                borderRadius: "24px",
                padding: isMobile ? "24px" : "32px",
                boxShadow: "0 10px 30px rgba(0,0,0,0.1)",
                transition: "all 0.4s ease",
                position: "relative",
                overflow: "hidden",
                border: `2px solid transparent`,
              }}
              onMouseEnter={(e) => {
                e.currentTarget.style.border = `2px solid ${service.border}`;
              }}
              onMouseLeave={(e) => {
                e.currentTarget.style.border = "2px solid transparent";
              }}
            >
              {/* Background Icon */}
              <div
                style={{
                  position: "absolute",
                  top: "-20px",
                  right: "-20px",
                  fontSize: isMobile ? "80px" : "120px",
                  opacity: 0.1,
                  zIndex: 0,
                }}
              >
                {service.icon}
              </div>

              {/* Foreground Icon */}
              <div
                style={{
                  width: isMobile ? "64px" : "80px",
                  height: isMobile ? "64px" : "80px",
                  background: service.color,
                  borderRadius: "16px",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                  fontSize: isMobile ? "32px" : "40px",
                  marginBottom: "24px",
                  boxShadow: "0 10px 20px rgba(0,0,0,0.2)",
                  zIndex: 1,
                }}
              >
                {service.icon}
              </div>

              <h3
                style={{
                  fontSize: isMobile ? "20px" : "24px",
                  fontWeight: "bold",
                  color: "#1C1C1C",
                  marginBottom: "12px",
                  position: "relative",
                  zIndex: 1,
                }}
              >
                {service.title}
              </h3>

              <p
                style={{
                  color: "#6C757D",
                  marginBottom: "24px",
                  fontSize: isMobile ? "14px" : "16px",
                  position: "relative",
                  zIndex: 1,
                }}
              >
                {service.description}
              </p>

              <div
                style={{
                  fontSize: isMobile ? "16px" : "18px",
                  fontWeight: "bold",
                  marginBottom: "16px",
                  background: service.color,
                  WebkitBackgroundClip: "text",
                  WebkitTextFillColor: "transparent",
                  position: "relative",
                  zIndex: 1,
                }}
              >
                {service.price}
              </div>
            </motion.div>
          ))}
        </motion.div>
      </div>
    </section>
  );
}
